export default ({ brand }, afterColon) => {
  if (!afterColon) {
    return brand;
  }

  return `${brand}: ${afterColon}`;
};